import type { ValidationRule } from '@vuelidate/core'
import * as validators from '@vuelidate/validators'

import { useNuxtApp } from '#imports'

// https://github.com/vuelidate/vuelidate/issues/1164
const i18nValidator = (validator: ValidationRule): ValidationRule => {
  const { createI18nMessage } = validators
  const { $i18n } = useNuxtApp()
  const withI18nMessage = createI18nMessage({ t: $i18n.t.bind($i18n) })

  return withI18nMessage(validator)
}

export default i18nValidator
